import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    standalone: false
})
export class JoinPipe implements PipeTransform {

  transform(value: string[], separator = ","): any {
    return value.filter(Boolean).join(separator);
  }

}
